import * as _ from "lodash";
import { Action } from "redux";

import * as FetchActions from "../actions/FetchActions";
import * as ProcessListActions from "../actions/ProcessListActions";
import * as SelectProcessActions from "../actions/SelectProcessActions";

import { ListState } from "../model/ListState";
import { ProcessWithStatus } from "../model/ProcessWithStatus";

export function listState(state: ListState = new ListState(), action: Action): ListState {
    switch (action.type) {
        // TODO: Should we reset selected process IDs on change page as well?
        case SelectProcessActions.SELECT_PROCESSES: {
            const checkAction = action as SelectProcessActions.ProcessSelectionAction;
            return updateState(state, {
                selectedProcessIds: _.union(state.selectedProcessIds, checkAction.processIds)
            });
        }
        case SelectProcessActions.DESELECT_PROCESSES: {
            const deselectAction = action as SelectProcessActions.ProcessSelectionAction;
            return updateState(state, {
                selectedProcessIds: _.difference(state.selectedProcessIds, deselectAction.processIds)
            });
        }
        case SelectProcessActions.DESELECT_ALL_PROCESSES:
            return updateState(state, { selectedProcessIds: [] });

        case ProcessListActions.TOGGLE_VISIBLE_PROCESS_LIST_COLUMN: {
            const toggleColumnAction = action as ProcessListActions.ToggleVisibleProcessListColumn;
            return updateState(state, { visibleColumns: toggleVisibleColumns(toggleColumnAction.column, state.visibleColumns) });
        }

        case ProcessListActions.OPEN_CHANGELOG_MODAL:
            {
                const openChangeLogModalAction = action as ProcessListActions.OpenChangeLogAction;
                return updateState(state, { changeLogOpenForProcess: openChangeLogModalAction.processId });
            }

        case ProcessListActions.CLOSE_CHANGELOG_MODAL:
            return updateState(state, { changeLogOpenForProcess: null });

        case ProcessListActions.OPEN_TAG_MODAL: {
            const openTagModalAction = action as ProcessListActions.OpenTagModalAction;
            return updateState(state, { tagModalOpenForProcesses: openTagModalAction.processIds });
        }

        case ProcessListActions.CLOSE_TAG_MODAL:
            return updateState(state, { tagModalOpenForProcesses: null });

        case ProcessListActions.CHANGE_COUNTS_TIME_LIMIT: {
            const changeCountsTimeLimitAction = action as ProcessListActions.ChangeCountsTimeLimitAction;
            return updateState(state, { countsTimeLimitDays: changeCountsTimeLimitAction.newLimitDays });
        }

        case FetchActions.RECEIVE_PROCESSES:
            // on list refresh, always reset selections
            return updateState(state, { selectedProcessIds: [] });

        case ProcessListActions.FINISH_LIST_ACTION:
            // on list action completed, always reset selections
            return updateState(state, { selectedProcessIds: [] });

        case ProcessListActions.OPEN_PROCESS_VARIABLES_EDITOR_MODAL: {
            const openProcessVariablesEditorModalAction = action as ProcessListActions.OpenProcessVariablesEditorModalAction;
            return updateState(state, { processVariablesEditorOpenForProcess: openProcessVariablesEditorModalAction.processId });
        }

        case ProcessListActions.CLOSE_PROCESS_VARIABLES_EDITOR_MODAL:
            return updateState(state, { processVariablesEditorOpenForProcess: null });

        case ProcessListActions.OPEN_COLUMN_VISIBILITY_CONTROL:
            return updateState(state, { columnVisibilityControlOpen: true });

        case ProcessListActions.CLOSE_COLUMN_VISIBILITY_CONTROL:
            return updateState(state, { columnVisibilityControlOpen: false });

        case ProcessListActions.SET_ACTION_MENU_OPEN_FOR_PROCESS: {
            const actionMenuOpenForProcessAction = action as ProcessListActions.ActionMenuOpenForProcessAction;
            return updateState(state, { actionMenuOpenForProcess: actionMenuOpenForProcessAction.processId });
        }

        case ProcessListActions.REMOVE_ACTION_MENU_OPEN_FOR_PROCESS:
            return updateState(state, { actionMenuOpenForProcess: null });

        case ProcessListActions.SET_SELECT_CREATE_TEMPLATE_FROM_PROCESS_MODE_MODAL: {
            const openSelectCreateTemplateFromProcessModeModalAction = action as ProcessListActions.SetSelectCreateTemplateFromProcessModalModeAction;
            return updateState(state, { selectCreateTemplateFromProcessModeModal: openSelectCreateTemplateFromProcessModeModalAction.modalProps });
        }

        case ProcessListActions.SET_CREATE_TEMPLATE_FROM_PROCESS_MODAL: {
            const openCreateTemplateFromProcessModalAction = action as ProcessListActions.SetCreateTemplateFromProcessModalAction;
            return updateState(state, { createTemplateFromProcessModal: openCreateTemplateFromProcessModalAction.modalProps });
        }

        default:
            return state;
    }
}

function updateState<K extends keyof T, T>(state: T, update: Partial<ListState>) {
    return Object.assign({}, state, update);
}

export function toggleVisibleColumns(columnToToggle: keyof (ProcessWithStatus), currentVisibleColumns: Array<keyof (ProcessWithStatus)>)
    : Array<keyof (ProcessWithStatus)> {
    const visibleColumns = currentVisibleColumns.slice();
    const indexOfColumnName = visibleColumns.indexOf(columnToToggle);
    if (indexOfColumnName < 0) {
        visibleColumns.push(columnToToggle);
    } else {
        visibleColumns.splice(indexOfColumnName, 1);
    }
    return visibleColumns;
}
